import { Routes, Route } from 'react-router-dom';
import LayoutPage from './pages/Layout';

import HomePage from './components/dashboard/HomeComponent';
import AudiencePage from "./pages/AudiencePage";
import CustomerPage from "./pages/CustomerPage";
import CustomersPage from "./pages/CustomersPage";
import ContenidoRecomendado from "./pages/ContenidoRecomendado";
import NewslettersPage from "./pages/NewslettersPage";
import AudioPage from "./pages/AudioPage";

const DashboardPage = () => {
  return (
    <LayoutPage>
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="audiencias" element={<AudiencePage />} />
        <Route path="usuarios" element={<CustomersPage />} />
        <Route path="usuarios/:id" element={<CustomerPage />} />
        <Route path="contenido-recomendado" element={<ContenidoRecomendado />} />
        <Route path="newsletters" element={<NewslettersPage />} />
        <Route path="audio" element={<AudioPage />} />        
      </Routes>
    </LayoutPage>
  );
};

export default DashboardPage;
